const { cond } = require("lodash");

const formTools = {
    reloadPage: function () {
        setTimeout(function () {
            location.reload();
        }, 2000)
    },

    isValidEmail: function (email) {
        const pattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return pattern.test(email);
    },

    isValidPhone: function (phone) {
        const pattern = /^[+]{0,1}[0-9-()]{7,}$/;
        return pattern.test(phone);
    },

    errorRequest: function (errorName, form) {
        const requestError = form.find(`.js__error_request[data-error=${errorName}]`);
        const wrapper = requestError.closest('.form__item');

        requestError.slideDown('slow');
        wrapper.addClass('error_input');
    },

    clearForm: function (form) {
        form.find('input[type="text"], textarea').val('');
        form.find('input[name=policy_agree]').prop('checked', false);
        $('.js__list_file').empty();
    },

    toggleButton: function (toggle, form = '') {
        const elements = form == '' ? $('.js__login_system') : form.find('.form__button');

        if (toggle == 'disabled') {
            elements.addClass('disabled').prop('disabled', true);
        } else if (toggle == 'unDisabled') {
            elements.removeClass('disabled').prop('disabled', false);
            $('.js__login_system').removeClass('disabled').prop('disabled', false);
        }
    },

    lockSystem: function (btn = '') {
        btn.closest('.js__lock_system').addClass('error_system');
        $('.js__login_system').removeClass('disabled').prop('disabled', false);
    },

    learnPrivatePolicy: function (form) {
        const input = form.find('input[name=policy_agree]');
        const wrapper = input.closest('.form__item');

        if (input.length > 1) {
            if (input.is(':checked')) {
                return true;
            } else {
                formTools.showError(wrapper, '.js__police_not_accept');
            }
        } else {
            return true
        }
    },

    showError: function (wrapper, selector) {
        wrapper.addClass('error_input');
        wrapper.find(selector).slideDown('slow');
    },

    clearErrors: function (wrapper) {
        wrapper.removeClass('error_input');
        wrapper.find('.error_required').hide();
    },

    clearAllErrors: function () {
        $('.input_wrapper').removeClass('error_input');
        $('.error_required').hide();
    },

    sortRequestForm: function (name, objectData, form = '') {
        const additionalSettings = {
            "thankYouModal": false,
            "form": form,
        };

        const sendObject = {
            'subj': false,
            'data': objectData,
        }

        switch (name) {
            case 'designRequests':
                sendObject.subj = 'design_requests';
                break;

            case 'subscribe':
                sendObject.subj = 'subscribe';
                break;

            case 'feedback':
                sendObject.subj = 'feedback';
                break;
        }

        this.postSend(sendObject, additionalSettings);
    },

    postSend: function (sendObject, additionalSettings) {
        $.post(request.postSend, sendObject, function (data) {
            if (data.status == 'success') {
                formTools.clearForm(additionalSettings['form']);

                if (sendObject.subj == 'subscribe') {
                    $('.js_footer__content_subscribe').addClass('active')

                    setTimeout(function() {
                        $('.js_footer__content_subscribe').removeClass('active')
                    }, 10000)
                }
            }
        });
    },

};

$(document).ready(function () {
    $(document).on('input', '.form__input', function () {
        const wrapper = $(this).closest('.form__item');
        formTools.clearErrors(wrapper);
    });

    $(document).on('submit', '.js__valid_form', function (e) {
        e.preventDefault();

        const form = $(this);
        const requestName = form.data('form');
        const objectData = {
            'lang': lang,
        };

        const files = {};

        if (!formTools.learnPrivatePolicy(form)) {
            return;
        }

        formTools.toggleButton('disabled', form);

        formTools.clearAllErrors();
        let error = 0;

        form.find('input, textarea').each(function () {
            const input = $(this);
            const name = input.attr('name');
            const wrapper = input.closest('.form__item');
            let value = input.val().trim();

            if (wrapper.hasClass('required')) {
                if (value === '') {
                    formTools.showError(wrapper, '.js__main_error');
                    error++;
                } else if ((name === 'login' || name === 'email') && !formTools.isValidEmail(value)) {
                    formTools.showError(wrapper, '.js__not_valid_email_error');
                    error++;
                } else if (name === 'phone' && !formTools.isValidPhone(value)) {
                    formTools.showError(wrapper, '.js__not_valid_phone_error');
                    error++;
                } else if (name === 'phone' && formTools.isValidPhone(value)) {
                    objectData['phone'] = value.replace(/\D/g, '');
                }
            }

            if (input.hasClass('js__file_add_hidden')) {
                files[name] = value;
            } else if (name !== 'phone') {
                objectData[name] = value;
            }
        });

        objectData['files'] = files;

        console.log(error)

        if (error === 0) {
            formTools.sortRequestForm(requestName, objectData, form);
        } else {
            formTools.toggleButton('unDisabled', form);
        }
    });
});